
  import { Component, Vue, Prop } from 'vue-property-decorator'
  import { commonModule, expensesModule, filterModule, jobsModule, labelModule, paymentsModule } from '@/store/modules/store-accessor'
  import { isDecimalNumber, getOptimalTextColor } from '@/helpers/data';
  import AssigneeCombo from '@/components/Combobox/AssigneeCombo.vue';
  import LabelCombo from '@/components/Combobox/LabelCombo.vue';
  import _ from 'lodash';
  import dayjs from 'dayjs';
  import { greekSearchFilter } from "@/helpers/data";

  @Component({
    components: {
      AssigneeCombo,
      LabelCombo,
    },
  })
  export default class AddCompanyExpenseModal extends Vue {
    @Prop()
    payload!: any;

    greekSearchFilter = greekSearchFilter;

    createdAtMenu = false;
    createAtTimeMenu = false;
    isAddingExpense = false;

    expenseModel = {
      cost: '',
      notes: '',
     assignee_id: '',
     payment_type: this.paymentTypesCombo[0],
     created_at_date: dayjs().format('YYYY-MM-DD'),
     created_at_time: dayjs().format('HH:mm'),
     expense_label_id: null,
    }

    fileModel = {
      add_file: false,
      file: null,
      url: null,
    }

    userRule = [
      (val: any) => !!val || this.$i18n.t("user_required"),
    ]
    notesRule = [
      (val: any) => {
        if(val != null) return val.length <= 30 || this.$i18n.t("notesThirtyCharsRule");
        else return true;
      },
    ]
    costRule:any = [
      (val: any) => val !== '' && val > 0 || this.$i18n.t("nonZeroCost")
    ]

    fileRules = [
      (val: any) => !!val || this.$t('fileRequired'),
      (val: any) => !val || val.size <= 5000000 || this.$i18n.t("fileInputSizeRule", { max: 5 }), // 5mb rule
    ]

    paymentTypeRule = [
      (val: any) => (val || '').id > 0 || this.$i18n.t("payment_type_required"),
    ]

    get assigneeIdCombo () {
        return commonModule.personnelCombo;
    }

    get paymentTypesCombo () {
      for (let i = 0; i < commonModule.paymentTypeCombo.length; i++) {
        (commonModule.paymentTypeCombo[i]["payment_type"] as any) = this.$t(commonModule.paymentTypeCombo[i]["payment_type"]);
      }
      return commonModule.paymentTypeCombo;
    }

    get expenseLabelsCombo() {
      return commonModule.expenseLabelsCombo;
    }
  
    async hideModal () {
      commonModule.hideModal();
    }

    async mounted() {
      commonModule.initSnackbar({});
      await commonModule.getPersonnelPartnersCombo();
      this.expenseModel.assignee_id = (this.getAssigneeId(commonModule.user.uuid) as any)
      await commonModule.getPaymentTypeCombo();
      await commonModule.getExpenseLabelsCombo();
    }

    updateAssignee(assignee: any) {
      if(assignee) {
        this.expenseModel.assignee_id = assignee;
      }
    }

    updateLabel(label: any) {
      this.expenseModel.expense_label_id = label;
    }
  
    optimalTextColor(color: string) {
      return getOptimalTextColor(color);
    }

    async doAddExpense () {
      this.isAddingExpense = true;
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        const expenseId: any = await expensesModule.addeExpense(this.expenseModel);
          if (this.fileModel.add_file) {
            let formData = new FormData();
            formData.append("file", (this.fileModel.file as any));
            formData.append("expenseId", expenseId);
            await expensesModule.addExpenseFile({expenseId: expenseId, file: formData});
          }
          if(this.$route.name === 'My Company') {
            await paymentsModule.getPaymentsAction(paymentsModule.filters);
            await paymentsModule.getPaymentsTotals(paymentsModule.filters);
            await labelModule.getExpenseLabels();
            await filterModule.getPaymentsAndExpensesFilters();
          }
          this.hideModal();
      }
      this.isAddingExpense = false;
    }

    onlyDecimalNumbers(evt: any) {
      isDecimalNumber(evt);
    }

    getAssigneeId(uuid: string) {
        const combo: any = commonModule.personnelPartnersCombo;
        const foundItem = combo.find((item: any) => item.id === uuid);
        if(foundItem) {
          return { name: foundItem.name, id: foundItem.id };
        } else {
          return ''
        }
      }

  };
  